import BlogProvider from "../provider/BlogProvider"
import BlogPosts from "./List"

export type BlogModel = {
  source: number
}

function BlogLayout() {
  return (
    <div className="grid-x grid-margin-x">
      <div className="cell small-12 medium-12">
        <div>
          <BlogPosts />
        </div>
      </div>
    </div>
  )
}

export default function Blog({ source }: BlogModel) {
  return (
    <BlogProvider source={source}>
      <BlogLayout />
    </BlogProvider>
  )
}